module.exports = __webpack_public_path__ + "img/saveImg.f7ff932a.svg";